import React from 'react';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import MainContentContainer from '../../../../../v2BaseComponents/MainContentContainer';
import useNotes from '../../../../../../hooks/api/useNotes';
import { useOrganizationId } from '../../../../../../hooks/api/useOrganization';
import NotesTable from './NotesTable';
import { useIsMobileLayout } from '../../../../../../hooks/useIsMobileLayout';

export type NotesTabOwnProps = {};

export type NotesTabProps = NotesTabOwnProps;

const NotesTab: React.FC<NotesTabProps> = () => {
    const isMobile = useIsMobileLayout();
    const organizationId = useOrganizationId();
    const { isLoading } = useNotes({
        noteQueryArgs: {
            entityType: 'organization',
            organizationId,
        },
    });
    return (
        <AnimateLoadedContent isLoading={isLoading}>
            {() => (
                <MainContentContainer flex={1} style={isMobile ? {} : { paddingLeft: 0, paddingRight: 0 }}>
                    <NotesTable />
                </MainContentContainer>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(NotesTab);
